import React, { useEffect, useState } from 'react'
import Topbar from '../../Components/Topbar'
import LeftbarUser from '../../Components/LeftbarUser'
import BottomNavUser from '../../Components/BottomNavUser'

import profDefault from '../../Images/def.png'
import { Link } from 'react-router-dom'
import defaultCover from '../../Images/coverbg.jpg'
import Button from "react-bootstrap/Button";
import { app } from "../../firebase.js"
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { doc, getDoc, getFirestore } from "firebase/firestore";
import { useNavigate } from 'react-router-dom';

import { Card, Row, Col, ListGroup, Badge } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInstagram, faTiktok, faYoutube, faLinkedin, faFacebook, faTwitter } from "@fortawesome/free-brands-svg-icons"
import { faClock, faEye, faFaceSmile, faPhone, faUser, faWallet } from '@fortawesome/free-solid-svg-icons'

import { getDatabase, ref as dbRef, get, set, runTransaction } from "firebase/database";
import Chart from "react-apexcharts";
import { faShareAlt } from '@fortawesome/free-solid-svg-icons';
import swal from 'sweetalert';

import menn from '../../Images/men.png'


function UserProfile() {

  const auth = getAuth();
  const db = getFirestore(app);
  const navigate = useNavigate();
  const [Username, setUsername] = useState("")
  const [UserEmail, setUserEmail] = useState("")

  const [userId, setUserId] = useState()

  const [dateJoined, setDateJoined] = useState("");
  const [profileViews, setProfileViews] = useState(0);

  const rdb = getDatabase(app);

  const [profileData, setProfileData] = useState({
    userName: "",
    theUsername: "",
    email: "",
    phoneNumber: "",
    profileImage: profDefault,
    coverImage: defaultCover,
    region: ""
  });

  useEffect(() => {
    document.title = "Zindua App | Dashboard";

    // Meta description
    let desc = document.querySelector("meta[name='description']");
    if (!desc) {
      desc = document.createElement("meta");
      desc.setAttribute("name", "description");
      document.head.appendChild(desc);
    }
    desc.setAttribute("content", "Zindua App dashboard");

    // Open Graph tags
    const ogTags = [
      { property: "og:title", content: "Zindua App | Dashboard" },
      { property: "og:description", content: "Zindua App Dashboard" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://zindua.app/dashboard" },
      { property: "og:image", content: "https://zindua.app/logo192.png" },
    ];

    ogTags.forEach(({ property, content }) => {
      let tag = document.querySelector(`meta[property='${property}']`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("property", property);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    });

    // JSON-LD structured data
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Zindua App Influencer Dashboard",
      "url": "https://zindua.app/dashboard",
      "description": "Zindua App influencer dashboard where you can manage your earnings, running ads, subscriptions, and withdraw funds to M-Pesa.",
      "inLanguage": "en",
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": "https://zindua.app/"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Dashboard",
            "item": "https://zindua.app/dashboard"
          }
        ]
      }
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  useEffect(() => {
    const cached = localStorage.getItem("profileData")
    if (cached) setProfileData(JSON.parse(cached))

    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        navigate("/login")
        return
      }

      const uid = user.uid
      setUserId(uid)

      const docRef = doc(db, "users", uid)
      const snap = await getDoc(docRef)

      if (snap.exists()) {
        const data = snap.data()

        // Log selected platforms
        const fresh = {
          userName: data.userName || "",
          theUsername: data.countryName || "",
          region: data.region || "",
          email: data.email || "",
          phoneNumber: data.phoneNumber || "",
          mpesaNumber: data.mpesaNumber || "",
          profileImage: data.profileImage || profDefault,
          coverImage: data.coverImage || defaultCover,
        }


        const old = JSON.parse(localStorage.getItem("profileData") || "{}")
        if (JSON.stringify(old) !== JSON.stringify(fresh)) {
          setProfileData(fresh)
          localStorage.setItem("profileData", JSON.stringify(fresh))
        }

        // --- Date Joined ---
        if (data.timestamp) {
          const joinDate = data.timestamp.toDate ? data.timestamp.toDate() : new Date(data.timestamp)
          const now = new Date()
          const diffMs = now - joinDate
          const diffSeconds = Math.floor(diffMs / 1000)
          const diffMinutes = Math.floor(diffSeconds / 60)
          const diffHours = Math.floor(diffMinutes / 60)
          const diffDays = Math.floor(diffHours / 24)
          const diffMonths = (now.getFullYear() - joinDate.getFullYear()) * 12 + (now.getMonth() - joinDate.getMonth())
          const diffYears = now.getFullYear() - joinDate.getFullYear()

          let joinedText = ""
          if (diffSeconds < 60) joinedText = `${diffSeconds} second${diffSeconds !== 1 ? "s" : ""} ago`
          else if (diffMinutes < 60) joinedText = `${diffMinutes} minute${diffMinutes !== 1 ? "s" : ""} ago`
          else if (diffHours < 24) joinedText = `${diffHours} hour${diffHours !== 1 ? "s" : ""} ago`
          else if (diffDays < 30) joinedText = `${diffDays} day${diffDays !== 1 ? "s" : ""} ago`
          else if (diffMonths < 12) joinedText = `${diffMonths} month${diffMonths !== 1 ? "s" : ""} ago`
          else joinedText = `${diffYears} year${diffYears !== 1 ? "s" : ""} ago`

          setDateJoined(joinedText)
        }


        // --- Profile Views ---
        const viewsRef = dbRef(rdb, `profileViews/${uid}`)
        runTransaction(viewsRef, (current) => (current || 0) + 1)
          .then(result => setProfileViews(result.snapshot.val()))
          .catch(err => console.error("Profile view error:", err))
      }
    })

    return () => unsubscribe()
  }, [])



  const { userName, theUsername, region, email, phoneNumber, mpesaNumber, profileImage, coverImage, adsNotAccepted, socials, socialUrls } = profileData;


  return (
    <div className="mainDashboard">
      <div className="desktopOnly">
        <LeftbarUser />
      </div>
      <div className="mainContent">
        <Topbar />
        <section className='topProfile'>

          <div className='profileCover'>
            <img src={coverImage} alt="" />
          </div>

          <div className='profilePhoto'>
            <img src={profileImage} alt="" />
          </div>

          <div className='topProfileCont'>
            <div>
              <h2>{userName}</h2>
              <p>{theUsername}
              </p>

            </div>

            <Link to="/user/edit-profile">Edit Profile</Link>
          </div>



          <section className='profileStatMain'>
            <div className='profileStatMain1 justAnAddon'>
              <div className='profileStatMain1Top '>
                <div className='profileStatMain1Top1'>
                  <FontAwesomeIcon icon={faFaceSmile} /> <span>Profile</span>
                </div>
                <div className='profileStatMainCont'>
                  <p>{userName}</p>
                  <h6>Date Joined</h6>
                  <p><FontAwesomeIcon icon={faClock} /> {dateJoined}</p>
                  <h6>Phone number</h6>
                  <p><FontAwesomeIcon icon={faPhone} /> {mpesaNumber}</p>

                </div>
              </div>
              <div className='profileStatMain1Bott'></div>
            </div>

            <div className='profileStatMain2 userProfileContt'>
              <img src={menn} alt="" />
              <p>Tell your Brand story with Influencer Marketing</p>

            </div>
          </section>
        </section>
      </div>
      <div className="mobileOnly">
        <BottomNavUser />
      </div>
    </div>
  )
}

export default UserProfile